/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceId } from './InstanceId';
import {
    InstanceIdFromJSON,
    InstanceIdFromJSONTyped,
    InstanceIdToJSON,
} from './InstanceId';

/**
 * 
 * @export
 * @interface InstanceLogEventSchema
 */
export interface InstanceLogEventSchema {
    /**
     * 
     * @type {number}
     * @memberof InstanceLogEventSchema
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InstanceLogEventSchema
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof InstanceLogEventSchema
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceLogEventSchema
     */
    logType?: string;
    /**
     * 
     * @type {InstanceId}
     * @memberof InstanceLogEventSchema
     */
    instanceId?: InstanceId;
    /**
     * 
     * @type {number}
     * @memberof InstanceLogEventSchema
     */
    taskId?: number;
    /**
     * 
     * @type {string}
     * @memberof InstanceLogEventSchema
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceLogEventSchema
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceLogEventSchema
     */
    stateColor?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InstanceLogEventSchema
     */
    stateFilled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InstanceLogEventSchema
     */
    stateExplanation?: string;
}

/**
 * Check if a given object implements the InstanceLogEventSchema interface.
 */
export function instanceOfInstanceLogEventSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function InstanceLogEventSchemaFromJSON(json: any): InstanceLogEventSchema {
    return InstanceLogEventSchemaFromJSONTyped(json, false);
}

export function InstanceLogEventSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceLogEventSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'timestamp': json['timestamp'],
        'message': json['message'],
        'logType': !exists(json, 'log_type') ? undefined : json['log_type'],
        'instanceId': !exists(json, 'instance_id') ? undefined : InstanceIdFromJSON(json['instance_id']),
        'taskId': !exists(json, 'task_id') ? undefined : json['task_id'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'stateColor': !exists(json, 'state_color') ? undefined : json['state_color'],
        'stateFilled': !exists(json, 'state_filled') ? undefined : json['state_filled'],
        'stateExplanation': !exists(json, 'state_explanation') ? undefined : json['state_explanation'],
    };
}

export function InstanceLogEventSchemaToJSON(value?: InstanceLogEventSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'timestamp': value.timestamp,
        'message': value.message,
        'log_type': value.logType,
        'instance_id': InstanceIdToJSON(value.instanceId),
        'task_id': value.taskId,
        'source': value.source,
        'state': value.state,
        'state_color': value.stateColor,
        'state_filled': value.stateFilled,
        'state_explanation': value.stateExplanation,
    };
}

